export default __webpack_public_path__ + "static/media/i085jp.7b73430d.webp";